export const ACCESS_TOKEN = "access_token";

export const PAGE_OPTIONS = [10, 50, 100]?.map((item) => ({
  value: `${item}`,
  label: `${item}`,
}));

export const COMMON_DEBOUNCE_DELAY = 300;

export const POLICY_KEY = "POLICY_KEY";
